import { useConfigService } from '@thd-nucleus/experience-context';
import { SEARCH_BANNER_CONFIG_KEY } from '../data-model/constants';

/**
 * Reads the ai-assisted-search-banner Config Service switch, which the A/B test ships as
 * `{ variant, row }` — the row places the banner in the grid and is the grid's concern. A plain
 * string is still accepted.
 *
 * Whether the variant is renderable is the variant registry's call, so there is no second list of
 * known variants here; anything that is not a string reads as absent.
 *
 * @returns {(string|undefined)} The configured variant, or undefined when the switch is absent.
 */
export const useSearchBannerVariant = () => {
  const config = useConfigService(SEARCH_BANNER_CONFIG_KEY);
  const variant = typeof config === 'string' ? config : config?.variant;

  return typeof variant === 'string' ? variant : undefined;
};
